import { useEffect, useState } from "react";
import ProjectList from "../ProjectList/ProjectList";
import "./Work.scss";
import {
  OtherPortfolio,
  dataSciencePortfolio,
  mobilePortfolio,
  webPortfolio,
  featuredPortfolio,
  ComputerVisionPortfolio,
} from "../../Data/Data";

export default function Work() {
  const [selected, setselected] = useState("featured");
  const [data, setdata] = useState([]);

  const list = [
    {
      id: "featured",
      title: "Featured",
    },
    {
      id: "mobile",
      title: "Mobile App",
    },
    {
      id: "web",
      title: "Web App",
    },
    {
      id: "DataScience",
      title: "Data Science",
    },
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setdata(featuredPortfolio);
        break;
      case "mobile":
        setdata(mobilePortfolio);
        break;
      case "web":
        setdata(webPortfolio);
        break;
      case "DataScience":
        setdata(dataSciencePortfolio);
        break;
      case "ComputerVision":
        setdata(ComputerVisionPortfolio);
        break;
      case "other":
        setdata(OtherPortfolio);
        break;

      default:
        setdata(featuredPortfolio);
        break;
    }
  }, [selected]);

  return (
    <div className="Work">
      <h1>Projects Done</h1>
      <p className='Note'>
        Note : Many of my freelance and some personal project is not uploaded, I
        upload them soon. 
      </p>
      <ul>
        {list.map((item) => (
          <ProjectList
            title={item.title}
            active={selected === item.id}
            setselected={setselected}
            id={item.id}
          />
        ))}
      </ul>
      <div className="container">
        {data.map((d) => (
          <div onClick={() => window.open(d.githubUrl)} className="item">
            <img src="assets/Thumbnail.jpg" alt="" />
            <h3>{d.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}
